export class SubscriptionModel {
  subscriptionSelected?: any;
  productOffer?: any;
  claimNumberList?: any;
  ContractualDocuments?: any;
}
